import { GET_QUESTIONS, RECEIVE_QUESTIONS, SAVE_QUESTION, SAVED_QUESTION } from '../questions/actions'
import { selectQuestions } from '../questions'

export const questionsProviders = (state = {}, action) => {
    const { providerId } = action
    
    switch (action.type) {
        case GET_QUESTIONS:
            if (!providerId)
                return state
            return {
                ...state,
                [providerId]: {
                    id: providerId,
                    ...state[providerId],
                    loading: true
                }
            }

        case RECEIVE_QUESTIONS:
            if (!providerId)
                return state
            return {
                ...state,
                [providerId]: {
                    ...state[providerId],
                    questionIds: action.questions.map(q => q.id),
                    loading: false
                }
            }

        case SAVE_QUESTION:
            if (!providerId)
                return state
            const provider = state[providerId]
            if (provider.questionIds.indexOf(action.question.id) !== -1)
                return state

            return {
                ...state,
                [provider.id]: {
                    ...provider,
                    questionIds: [action.question.id, ...provider.questionIds]
                }
            }

        case SAVED_QUESTION:
            const { prevId } = action
            let changed = false
            const providers = Object.keys(state).map(id => {
                const provider = state[id]
                const { questionIds } = provider
                const prevQuestionIndex = questionIds.indexOf(prevId)
                if (prevQuestionIndex === -1)
                    return provider
                
                changed = true
                return {
                    ...provider,
                    questionIds: [
                        ...questionIds.slice(0, prevQuestionIndex),
                        action.question.id,
                        ...questionIds.slice(prevQuestionIndex + 1)
                    ]
                }
            })
            if (!changed)
                return state
            return providers.reduce((newState, provider) => {
                newState[provider.id] = provider
                return newState
            }, {})


        default:
            return state
    }
}


export const selectProvider = (state, id) => {
    const provider = state.questionsProviders[id] || {}
    return {
        id,
        ...provider,
        questions: selectQuestions(state, provider.questionIds || [])
    }
}


// WEBPACK FOOTER //
// ./src/reducers/questionsProviders/index.js